import { FormSection } from '@ksyos/design-system';
import type { OsasTreatmentChoiceCustomControlData } from '@common/validation/customControls/osas/osasTreatmentChoice/types';
import { useOsasAllTreatments } from '@frontend/utils/hooks/useOsasAllTreatments';
import { useProcessActivityEditContext } from '@frontend/utils/hooks/useProcessActivityContext';
import { TherapielandProgrammesEdit } from '../../../therapielandProgrammes/TherapielandProgrammesEdit';
import { TextAreaFormGroup } from '../../processActivityFormGroupFields';
import { HasChosenTreatmentFields } from '../osasConsult/components/policyFormSection/HasChosenTreatmentFields';
import { TreatmentFormSection } from '../osasConsult/components/treatmentFormSection/TreatmentFormSection';
import { TreatmentToBreakFormSection } from './components/TreatmentsToBreakFormSection';

export function OsasTreatmentChoiceEdit() {
    const { errors, data, onChange } = useProcessActivityEditContext<OsasTreatmentChoiceCustomControlData>();
    const { onBreakTreatments, onChangeTreatment, hasInProgressTreatments, inProgressTreatments } =
        useOsasAllTreatments({ onChange });

    return (
        <>
            {hasInProgressTreatments && (
                <TreatmentToBreakFormSection
                    data={data}
                    errors={errors}
                    inProgressTreatments={inProgressTreatments}
                    onBreakTreatments={onBreakTreatments}
                    onChange={onChange}
                />
            )}

            <FormSection title={hasInProgressTreatments ? 'Nieuwe therapie starten' : undefined}>
                <TreatmentFormSection
                    data={data}
                    errors={errors}
                    onChange={(updatedData, validateKeys) => {
                        onChange(updatedData, validateKeys);
                        onChangeTreatment(updatedData.treatment);
                    }}
                />

                <TextAreaFormGroup
                    fieldKey="taskForPoliclinic"
                    label="Taak voor de Ksyos poli"
                />

                <TherapielandProgrammesEdit
                    checkedTreatments={data.checkedTreatments}
                    errors={errors}
                    onChange={onChange}
                />

                <HasChosenTreatmentFields
                    data={data}
                    onChange={onChange}
                />
                <TextAreaFormGroup
                    fieldKey="remarkOther"
                    label="Overige opmerkingen"
                    value={data.remarkOther}
                />
            </FormSection>
        </>
    );
}
